// THIS IS A GENERATED FILE, DO NOT EDIT
import { __assign } from "tslib";
import * as React from 'react';
import { Icon } from '../Icon';
export default React.forwardRef(function Wrench(props, ref) {
    return (React.createElement(Icon, __assign({}, props, { name: "Wrench" }),
        React.createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ref: ref },
            React.createElement("path", { d: "M20.4585 6.1477C21.4419 8.20113 21.0861 10.7326 19.3891 12.4296C17.6922 14.1266 15.1606 14.4824 13.1072 13.499L5.60624 21L3 18.3938L10.501 10.8928C9.51762 8.83936 9.87343 6.30785 11.5704 4.61088C13.2674 2.91391 15.7989 2.55811 17.8523 3.54146L13.9429 7.45082L16.5492 10.0571L20.4585 6.1477Z", fill: "currentColor" }))));
});
//# sourceMappingURL=Wrench.js.map